<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
        <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
            <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentMail">
                <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
                    <div class="flex mb-4">
                        <div class="flex items-center">
                            <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                            <h4 v-if="currentMail.title">{{ currentMail.title }}</h4>
                            <h4 v-else>(nooooo subject)</h4>
                        </div>
                    </div>
                    <div class="ml-10 mb-4 mt-1">
                        <div class="email__actions--single flex items-baseline">

                            <!--feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current stroke-current': currentMail.isStarred}, 'h-6 w-6']" @click="toggleIsStarred" />

                            
                            <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                                <feather-icon icon="TagIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4"></feather-icon>
                                <vs-dropdown-menu style="z-index: 40001">
                                        <vs-dropdown-item v-for="(label, index) in emailTags" :key="index">
                                            <vs-checkbox @click.stop :vs-value="label.value" v-model="currentMailLabels">{{ label.text }}</vs-checkbox>
                                        </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>

                            <feather-icon icon="MailIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="$emit('markUnread')"></feather-icon-->
                            <feather-icon v-if="currentMail.mailFolder != 'trash'" icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="supprima"></feather-icon>
                            <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
                            <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" />
                        </div>
                    </div>
                </div>

                <VuePerfectScrollbar class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
                <!-- LABEL ROW -->
                
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="email__labels--single flex ml-10 items-center mt-2">
                            <transition-group name="list" tag="div" class="flex">
                                <div v-for="label in currentMail.labels" :key="label" class="open-mail-label flex items-center mr-4">
                                    <div class="h-3 w-3 rounded-full mr-1" :class="'bg-' + labelColor(label)"></div>
                                    <span class="text-sm">{{ label | capitalize }}</span>
                                </div>
                            </transition-group>
                        </div>
                    </div>
                </div>
                <!-- /LABEL ROW 
                <br>

                <div class="vx-row mb-4" v-if="currentMail.replies.length && !showThread">
                    <div class="vx-col w-full">
                        <span class="text-primary font-medium ml-10 cursor-pointer" @click="showThread = true">{{ currentMail.replies.length }} Earlier Messages</span>
                    </div>
                </div>-->
                <div v-if="isSidebarActive">

                    <!-- ALL MESSAGES - THREAD 
                    <div class="vx-row" v-for="threadMail in currentMail.replies.slice().reverse()" :key="threadMail.id" v-if="showThread">
                        <div class="vx-col w-full">
                            <email-mail-card :mailContent="threadMail" class="mb-10" />
                        </div>
                    </div>-->

                    <!-- LATEST MESSAGE -->
                    <div class="vx-row">
                        <div class="vx-col w-full">
                          <vx-card class="px-4" >
    <!-- MAIL HEAD -->
    <div class="vx-row">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <!-- Sender Details -->
        <div class="flex items-center">
          <div>
            <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white" :src="currentMail.avatar" size="65px" />
          </div>

          <div class="flex flex-col">
            <h5 class="mb-1">{{ currentMail.nomPrenom }}</h5>
            <div class="flex items-center">
              <span class="text-sm">{{ currentMail.title }}</span>
              
            </div>
          </div>
        </div>
        <!-- /Sender Details -->

        <!-- Mail Time & Date -->
        <div class="flex flex-col justify-end">
          <span class="text-right">{{ currentMail.time | time }}</span>
          <div class="flex justify-end mt-2">
            <span class="text-right">{{ ' ' }}{{ currentMail.Date }}</span>
          </div>
        </div>
      </div>
      <!-- /Mail Time & Date -->
    </div>

    <!-- MAIL CONTENT -->
    <div class="vx-row" v-if="currentMail.title==='Demande inscrie'">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <div v-if="currentMail.description===''" class="mail__content break-words mt-8 mb-4" v-html="currentMail.description"></div>
        <div v-if="currentMail.description!=''" class="mail__content break-words mt-8 mb-4" v-html="currentMail.description"></div>
      </div>
    </div>
    <div class="vx-row" v-if="currentMail.title==='Ajouter groupe' ">
      
      <div v-if="currentMail.classePasPlan.length>0" class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                <p class="font-semibold ml-5 mt-5 mb-5">Groupe pas plein on cour</p>
                <div :data="tr" :key="indextr" v-for="(tr, indextr) in currentMail.classePasPlan"> 
                <span class="mr-5"> Croupe {{ tr.numero }}</span>
                </div>
      </div>
      <div v-if="currentMail.classePasPlan.length==0" class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                <p class="font-semibold ml-5 mt-5 mb-5">Toutes groupes sont pleins</p>
      </div>
    </div>
    <div class="vx-row" v-if="currentMail.title==='Candidat pas payé'">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <div class="mail__content break-words mt-8 mb-4" v-html="currentMail.title"></div>
      </div>
    </div>
    <div class="vx-row" v-if="currentMail.title==='Formateur pas été payé'">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <div class="mail__content break-words mt-8 mb-4" v-html="currentMail.title"></div>
      </div>
    </div>
    
      <div class="vx-row" v-if="currentMail.title==='Demande inscrie'">

          

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ currentMail.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ currentMail.formation }}</p></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Groupe</td>
                <td><vs-select class="selectExample ml-5" v-model="groupe_data"  placeholder="Groupe">
               <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in currentMail.classePasPlan" />
            </vs-select></td>
              </tr>
            </table>
            
          </div>
          
          <!-- /Information - Col 2 -->
        </div>
        <div class="vx-row" v-if="currentMail.title==='Demande inscrie'">
                                    <div class="vx-col w-full flex justify-between">
                                        <span class="text-lg"></span>
                                        <vs-button :disabled="!validateForm" class="mt-5 mr-5" color="primary" type="border" @click="ddddd">Accepter</vs-button>
                                    </div>
        </div>
              <div class="vx-row" v-if="currentMail.title==='Ajouter groupe'">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ currentMail.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ currentMail.formation }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Les demandes</td>
                <td ><p class="ml-5">{{ currentMail.nomber }}</p></td>
              </tr>
            </table>
          </div>
          
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
                <p ><span class="font-semibold">places disponibles</span> <span class="ml-5">{{ currentMail.nb_placeTotal }}</span></p>
                <div class="vx-col w-3/4 mb-3"><vs-progress class="block mt-1" :percent="currentMail.borcentage" :color="getPopularityColor(currentMail.borcentage)"></vs-progress></div>
                <div class="vx-col w-full flex justify-between">
                  <span class="text-lg"></span>
                  <vs-button  class="mt-5 mr-5" color="primary" type="border" @click="Ajouter">Ajouter Groupe</vs-button>
                </div>

          </div>
          
          <!-- /Information - Col 2 -->
        </div>
      <div class="vx-row" v-if="currentMail.title==='Candidat pas payé'">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ currentMail.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ currentMail.formation }}</p></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Groupe</td>
                <td><p class="ml-5">Groupe {{ currentMail.classe }}</p></td>
              </tr>
            </table>
            
          </div>
          
          <!-- /Information - Col 2 -->
        </div>
        <div class="vx-row" v-if="currentMail.title==='Formateur pas été payé'">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ currentMail.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ currentMail.formation }}</p></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Groupe</td>
                <td><p class="ml-5">Groupe {{ currentMail.classe }}</p></td>
              </tr>
            </table>
            
          </div>
          
          <!-- /Information - Col 2 -->
        </div>
  </vx-card>
                        </div>
                    </div>

                    <div class="vx-row" style="margin-top: 2.2rem">
                        <div class="vx-col w-full">
                            <vx-card>
                                <div class="vx-row">
                                    <div class="vx-col w-full flex justify-between">
                                        <span class="text-lg">Cliquez ici pour passer à la page <span class="text-primary font-semibold cursor-pointer"><router-link to="/application/classe/user-list" @click.stop.prevent class="text-inherit hover:text-primary">{{ 'Groupe' }}</router-link></span> </span>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
                </VuePerfectScrollbar>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import DataViewSidebar from '../../application/classe/DataViewSidebar.vue'
import moduleclasse from '@/store/classe/moduleclasse.js'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EmailMailCard from "./EmailMailCard.vue"
import modulecandidat from '@/store/candidat/modulecandidat.js'
import modulenotivication from '@/store/notification/modulenotification.js'

export default {
  props: {
    emailTags: {
      type: Array,
      required: true,
    },
    openMailId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    mailFilter: {
      type: String
    }
  },
  data() {
    return {
      addNewDataSidebar: false,
      sidebarData: {},
      groupe_data:'',
      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
  },
  computed: {
    validateForm() {
      return !this.errors.any() &&  this.groupe_data != '' ;

    },
    currentMail() {
      
      const user = this.$store.state.notivication.users.find(tt => tt.index === this.openMailId)
      
      return user
    },
    labelColor() {
      return (label) => {
        const tags = this.$store.state.email.mailTags
        return tags.find((tag) => {
          return tag.value == label
        }).color
      }
    },
    currentMailLabels: {
      get() {
        return this.currentMail.labels
      },
      set(value) {
        if (Array.isArray(value)) {
          const payload = { mailId: this.openMailId, labels: value }
          this.$store.dispatch('email/setLabels', payload)
        }
      }
    },
    
  },
  methods: {
    supprima(){
    this.$store.dispatch("notivication/removeRecord", this.currentMail.id_paticipation)
    this.$emit('removeMail')
    this.$store.dispatch("notivication/fetchUsers").catch(err => { console.error(err) })
    this.$store.dispatch("notivication/fetchUsers").catch(err => { console.error(err) })
    },
    Ajouter(){
      const tt={titre:this.currentMail.formation,formation_id:this.currentMail.id_formation}
    this.sidebarData = tt
    this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    getPopularityColor(num) {
      if(num > 70) return "primary"
      if(num >60) return "primary"
      if(num >= 40) return "warning"
      if(num < 40) return "danger"
      return "primary"
    },
    ddddd(){
      
      const obj = {id:this.currentMail.id_paticipation,paiment:0,candidat_id:this.currentMail.candidat_id,classe_id:this.groupe_data,etat:'accepter'}
      console.log(obj)
      this.$store.dispatch('candidat/updateParticipation', obj)
      
    this.$store.dispatch("notivication/fetchUsers").catch(err => { console.error(err) })
    this.$store.dispatch("notivication/fetchUsers").catch(err => { console.error(err) })
    },
    toggleIsStarred() {
      console.log('cv')
      const payload = { mailId: this.openMailId, value: !this.currentMail.isStarred }
      this.$store.dispatch('email/toggleIsMailStarred', payload)
    },
    moveTo(to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    }
  },
  components: {
    DataViewSidebar,
    VuePerfectScrollbar,
    EmailMailCard
  },
  updated() {
    if (!this.currentMail) return
    if (this.currentMail.unread && this.isSidebarActive) this.$store.dispatch('email/setUnread', { emailIds: [this.openMailId], unread: false });
  },
  created(){
    if(!moduleclasse.isRegistered) {
      this.$store.registerModule('classe', moduleclasse)
      moduleclasse.isRegistered = true
    }
    if(!modulecandidat.isRegistered) {
      this.$store.registerModule('candidat', modulecandidat)
      modulecandidat.isRegistered = true
    }
    console.log('ggfdgd')
    if(!modulenotivication.isRegistered) {
      this.$store.registerModule('notivication', modulenotivication)
      modulenotivication.isRegistered = true
    }
  }
  
}

</script>

